import { Order } from 'shell/view-models/order';
import { objectToQueryString, QuerySerializableObject } from './object-to-query-string';
import { OperationObject, operationObjectToQueryString } from './operation-object-to-query-string';

type CommonFieldsForList = {
  filters: OperationObject;
  orders: Order;
  page?: number;
  rowsPerPage?: number;
};

export const paginationListToQueryString = (values: CommonFieldsForList): string => {
  const { orders, page, rowsPerPage, filters } = values;

  const filtersQueryString = operationObjectToQueryString('filters', filters);
  const ordersObject = orders || {};
  const orderQueryString = objectToQueryString('sort', ordersObject as QuerySerializableObject);

  const pageOffset = (page || 0) * (rowsPerPage || 0);
  const hasPagination = page !== undefined && rowsPerPage !== undefined;

  const paginationString = hasPagination ? `pageOffset=${pageOffset}&pageSize=${rowsPerPage}` : '';

  const queryParts = [paginationString, filtersQueryString, orderQueryString]
    .filter((str) => !!str)
    .map((str) => str.trim());

  return queryParts.join('&');
};
